import { Link } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import FlyoutMenu from './FlyoutMenu';
import Image from 'next/image';

interface Props {
  campaigns: any;
}

function FlyoutMenuCampaign({ campaigns }: Props) {
  const t = useTranslations('shop');

  function getLink(item: any) {
    return {
      pathname: `/shop`,
      query: {
        tag: item.tag,
      },
    };
  }

  if (campaigns.items?.length === 0) {
    return null;
  }

  return (
    <FlyoutMenu fullWidth label={t('navbar.campaign.title')}>
      {({ close }) => (
        <div className="container mx-auto px-4 lg:px-6 xl:px-8 py-8 grid grid-cols-5 gap-8">
          {campaigns.items.slice(0, 10).map((campaign) => (
            <Link
              key={campaign._id}
              // @ts-expect-error
              href={getLink(campaign)}
              className="text-left no-underline group/item"
              onClick={close}
            >
              <div className="relative rounded-sm mb-2 h-32 aspect-video">
                <Image
                  fill
                  className="rounded-sm object-cover"
                  src={campaign.appBackgroundImageUrl}
                  alt={campaign.title}
                />
              </div>
              <h6
                className="text-base font-bold tracking-tight text-greyscale-title m-0 mb-0.5 group-hover/item:underline">
                {campaign.title}
              </h6>
              <div className="text-sm font-medium tracking-tight text-greyscale-label">
                {campaign.description}
              </div>
            </Link>
          ))}
        </div>
      )}
    </FlyoutMenu>
  );
}

export default FlyoutMenuCampaign;
